export default __webpack_public_path__ + "static/media/cover4.1d27aa8e.jpg";